module.exports = __webpack_public_path__ + "static/img/button.1fa1569c.png";